import { useEffect, useState } from 'react';
import { Input } from '@/shared/components';
import { I } from '@/shared/icons';
import { useDebounce } from '@/shared/hooks/useDebounce';

interface Props {
  value: string;
  onChange: (next: string) => void;
}

/**
 * Suchfeld der Apartmentliste.
 *
 * <p>Der Suchbegriff steht in der URL (§5), getippt wird aber lokal: ein Navigationsschritt je
 * Tastenanschlag hinterließe einen Verlauf, aus dem man sich rückwärts wieder heraustippen
 * müsste. Die URL bekommt den Wert erst, wenn die Eingabe steht.</p>
 */
export function PropertySearchField({ value, onChange }: Props) {
  const [text, setText] = useState(value);
  const debounced = useDebounce(text, 300);

  // Der Wert kann auch von außen kommen — „Filter zurücksetzen" oder ein geteilter Link.
  useEffect(() => setText(value), [value]);

  useEffect(() => {
    if (debounced !== value) onChange(debounced);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debounced]);

  return (
    <div className="relative max-w-md">
      <I
        name="Search"
        size={16}
        className="text-ink-faint pointer-events-none absolute left-4 top-1/2 -translate-y-1/2"
        aria-hidden
      />
      <Input
        aria-label="Apartments durchsuchen"
        placeholder="Nach Name oder Stadt suchen…"
        value={text}
        onChange={(e) => setText(e.target.value)}
        className="pl-11"
      />
    </div>
  );
}
